export default __webpack_public_path__ + "static/media/gallery_00.081883e0.jpg";